export const types = {
    login: '[Auth] Login',
    logout: '[Auth] Logout',
    authUpdateEmpresa: '[Auth] Update Empresa',
};
